import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EqualizerBarsProps {
    playing: boolean
    className?: string
}

const EqualizerBars: FC<EqualizerBarsProps> = ({ playing, className }): ReactNode => {
    return (
        <span aria-hidden className={cn('flex h-4 items-end gap-0.5', className)}>
            {[0, 1, 2, 3].map((bar) => (
                <span
                    key={bar}
                    className={cn(
                        'h-full w-1 origin-bottom rounded-full bg-current',
                        playing ? 'animate-eq motion-reduce:animate-none' : 'scale-y-[0.3]'
                    )}
                    style={{ animationDelay: `${bar * 0.15}s` }}
                />
            ))}
        </span>
    )
}

export default EqualizerBars
